<template>
  <div class="route-page" :class="{ 'is-en': isEn }">
    <site-header />
    <section class="page-banner" :style="{ backgroundImage: 'url(' + fileUrl('routeAdvantages/页头背景.png') + ')' }"></section>
    <section class="route-body">
      <article
        v-for="(item, index) in modes"
        :id="item.key"
        :key="item.key"
        class="block"
        :class="[item.side, { first: index === 0 }]"
        :style="{ height: item.layoutHeight + 'px' }"
      >
        <h1 v-if="index === 0" class="wow-bounce" data-anim="title" :class="animClass('title')">{{ copy.route.pageTitle }}</h1>
        <div class="panel" :style="{ height: item.panelHeight + 'px' }"></div>
        <img
          class="photo"
          :data-anim="item.key"
          :class="[item.side === 'img-left' ? 'wow-left' : 'wow-right', animClass(item.key)]"
          :style="{ height: item.photoHeight + 'px' }"
          :src="fileUrl(item.image)"
          :alt="item.name"
        >
        <div class="copy">
          <h2>{{ item.name }}</h2>
          <span class="en">{{ item.en }}</span>
          <p v-for="(para, pIndex) in item.paragraphs" :key="pIndex">{{ para }}</p>
        </div>
      </article>
    </section>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'

export default {
  name: 'RoutePage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      /** 各航线入场状态，in 表示正在播放或已播放 */
      animMap: {}
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 按路由语言取航线文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    },
    /** 各航线区块；英文高度取自官网 routeAdvantages_EN，中文保持原绝对定位尺寸 */
    modes() {
      const r = this.copy.route
      const en = this.isEn
      const paras = function () {
        return Array.prototype.slice.call(arguments).filter(function (p) {
          return !!(p && String(p).trim())
        })
      }
      return [
        {
          key: 'sea',
          side: 'img-left',
          layoutHeight: en ? 595 : 536,
          panelHeight: en ? 459 : 379,
          photoHeight: en ? 446 : 370,
          name: r.seaName,
          paragraphs: paras(r.seaP1, r.seaP2),
          en: 'Southeast Asia Route',
          image: 'routeAdvantages/东南亚航线.jpg'
        },
        {
          key: 'india',
          side: 'img-right',
          layoutHeight: 467,
          panelHeight: en ? 405 : 379,
          photoHeight: en ? 396 : 370,
          name: r.indiaName,
          paragraphs: paras(r.indiaP1, r.indiaP2),
          en: 'India Pakistan Route',
          image: 'routeAdvantages/印巴航线.jpg'
        },
        {
          key: 'med',
          side: 'img-left',
          layoutHeight: 606,
          panelHeight: 517,
          photoHeight: 507,
          name: r.medName,
          paragraphs: paras(r.medP1, r.medP2, r.medP3, r.medP4),
          en: 'Mediterranean Route',
          image: 'routeAdvantages/地中海航线.jpg'
        },
        {
          key: 'caribbean',
          side: 'img-right',
          layoutHeight: 537,
          panelHeight: 444,
          photoHeight: 436,
          name: r.caribbeanName,
          paragraphs: paras(r.caribbeanP1, r.caribbeanP2),
          en: 'Caribbean Route',
          image: 'routeAdvantages/加勒比航线.jpg'
        },
        {
          key: 'black',
          side: 'img-left',
          layoutHeight: en ? 542 : 482,
          panelHeight: en ? 480 : 391,
          photoHeight: en ? 468 : 382,
          name: r.blackName,
          paragraphs: paras(r.blackP1, r.blackP2),
          en: 'Black Sea Line',
          image: 'routeAdvantages/黑海线.jpg'
        },
        {
          key: 'red',
          side: 'img-right',
          layoutHeight: en ? 493 : 467,
          panelHeight: en ? 428 : 379,
          photoHeight: en ? 416 : 370,
          name: r.redName,
          paragraphs: paras(r.redP1, r.redP2),
          en: 'Red Sea Line',
          image: 'routeAdvantages/红海线.jpg'
        },
        {
          key: 'middle',
          side: 'img-left',
          layoutHeight: en ? 594 : 521,
          panelHeight: en ? 530 : 427,
          photoHeight: en ? 514 : 419,
          name: r.middleName,
          paragraphs: paras(r.middleP1, r.middleP2),
          en: 'Middle East Line',
          image: 'routeAdvantages/中东线.jpg'
        },
        {
          key: 'us',
          side: 'img-right',
          layoutHeight: 467,
          panelHeight: 379,
          photoHeight: 370,
          name: r.usName,
          paragraphs: paras(r.usP1, r.usP2),
          en: 'US Line',
          image: 'routeAdvantages/美线.jpg'
        },
        {
          key: 'europe',
          side: 'img-left',
          layoutHeight: en ? 500 : 467,
          panelHeight: en ? 403 : 379,
          photoHeight: en ? 388 : 370,
          name: r.europeName,
          paragraphs: paras(r.europeP1, r.europeP2),
          en: 'Europe Line',
          image: 'routeAdvantages/欧洲线.jpg'
        }
      ]
    }
  },
  mounted() {
    // 带锚点进入时先滚到对应航线，这一次由进页动画播放
    if (this.$route.hash) {
      this.scrollToHash(this.$route.hash)
    }
    // 监听滚入视口，首次进入页面时播放动画
    this.bindScrollAnim()
  },
  /** 二级菜单切换航线时，滚到目标并重新播放入场动画 */
  beforeRouteUpdate(to, from, next) {
    if (to.hash && to.path === from.path) {
      // 等路由滚到目标航线后，重播视口里的标题和图片动画
      this.replayAfterScroll(to.hash)
    }
    next()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
    clearTimeout(this.animTimer)
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 入场动画类名 */
    animClass(key) {
      if (this.animMap[key] === 'in') {
        return 'is-in'
      }
      return ''
    },
    /** 滚到二级菜单对应的航线，减去吸顶导航高度 */
    scrollToHash(hash) {
      const el = document.getElementById(hash.replace('#', ''))
      if (!el) {
        return
      }
      const top = el.getBoundingClientRect().top + window.pageYOffset - 104
      window.scrollTo(0, top)
    },
    /** 滚到目标航线后，把视口里的标题和图片动画重新播一遍 */
    replayAfterScroll(hash) {
      const self = this
      clearTimeout(this.animTimer)
      this.animTimer = setTimeout(function () {
        const el = document.getElementById(hash.replace('#', ''))
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - 104
          window.scrollTo(0, top)
        }
        const nodes = self.$el.querySelectorAll('[data-anim]')
        const viewHeight = window.innerHeight
        const keys = []
        for (let i = 0; i < nodes.length; i++) {
          const rect = nodes[i].getBoundingClientRect()
          if (rect.bottom > 104 && rect.top < viewHeight) {
            keys.push(nodes[i].getAttribute('data-anim'))
          }
        }
        keys.forEach(function (key) {
          self.$delete(self.animMap, key)
        })
        self.$nextTick(function () {
          window.requestAnimationFrame(function () {
            keys.forEach(function (key) {
              self.$set(self.animMap, key, 'in')
            })
          })
        })
      }, 80)
    },
    /** 滚进视口后播放官网动画：标题弹入，图片从左右滑入 */
    bindScrollAnim() {
      const self = this
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return
          }
          const key = entry.target.getAttribute('data-anim')
          if (!self.animMap[key]) {
            self.$set(self.animMap, key, 'in')
          }
          observer.unobserve(entry.target)
        })
      }, { threshold: 0 })
      this.observer = observer
      const nodes = this.$el.querySelectorAll('.wow-bounce, .wow-left, .wow-right')
      nodes.forEach(function (node) {
        observer.observe(node)
      })
    }
  }
}
</script>

<style scoped>
.route-page {
  background: #fff;
  color: #333;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.page-banner {
  height: 368px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 100%;
}
.route-body {
  max-width: 1200px;
  margin: 0 auto;
}
.block {
  position: relative;
  scroll-margin-top: 104px;
}
.block h1 {
  position: absolute;
  top: 23px;
  left: 42%;
  width: 12%;
  margin: 0;
  font-size: 32px;
  line-height: 35px;
  font-weight: normal;
  color: #086de1;
  text-align: center;
  border-bottom: 3px solid #086de1;
  white-space: nowrap;
}
/* 英文标题 Route Advantage 比中文宽，对齐官网 272px */
.route-page.is-en .block h1 {
  left: 446px;
  width: 272px;
}
.panel {
  position: absolute;
  top: 53px;
  left: 0;
  width: 100%;
  background: #305dc3;
  border-radius: 5px;
}
.block.first .panel { top: 130px; }
.photo {
  position: absolute;
  width: 45.8%;
  object-fit: fill;
  border-radius: 5px;
  box-shadow: 10px 10px 0 #e5e5e5;
}
.img-left .photo { top: 23px; left: 2.098958%; }
.img-right .photo { top: 22px; left: 51.432292%; }
.block.first .photo { top: 100px; left: 2.1%; }
.copy {
  position: absolute;
  width: 46.416667%;
  color: #fff;
}
.img-left .copy { top: 98px; left: 51.39974%; }
.img-right .copy { top: 99px; left: 2.233073%; }
.block.first .copy { top: 175px; left: 51.4%; }
.copy h2 {
  display: inline;
  margin: 0;
  font-size: 28px;
  line-height: 38px;
  font-weight: normal;
  color: #fff;
}
.copy .en {
  margin-left: 10px;
  color: #ccc;
  font-size: 14px;
  line-height: 25.2px;
}
.copy p {
  margin: 24px 0 0;
  color: #fff;
  font-size: 14px;
  line-height: 25.2px;
  text-indent: 2em;
}
.copy p + p {
  margin-top: 0;
}
.wow-bounce,
.wow-left,
.wow-right {
  opacity: 0;
}
.wow-bounce.is-in {
  opacity: 1;
  animation: routeBounceIn 1s 0.25s both;
}
.wow-left.is-in {
  opacity: 1;
  animation: routeSlideInLeft 1s 0.25s both;
}
.wow-right.is-in {
  opacity: 1;
  animation: routeSlideInRight 1s 0.25s both;
}
@keyframes routeBounceIn {
  0%, 20%, 40%, 60%, 80%, 100% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% { opacity: 0; transform: scale3d(0.3, 0.3, 0.3); }
  20% { transform: scale3d(1.1, 1.1, 1.1); }
  40% { transform: scale3d(0.9, 0.9, 0.9); }
  60% { opacity: 1; transform: scale3d(1.03, 1.03, 1.03); }
  80% { transform: scale3d(0.97, 0.97, 0.97); }
  100% { opacity: 1; transform: scaleX(1); }
}
@keyframes routeSlideInLeft {
  from { transform: translate3d(-100%, 0, 0); }
  to { transform: translateZ(0); }
}
@keyframes routeSlideInRight {
  from { transform: translate3d(100%, 0, 0); }
  to { transform: translateZ(0); }
}
@media (max-width: 800px) {
  .page-banner { height: 220px; }
  .block {
    height: auto !important;
    margin: 16px 12px;
    padding: 16px 12px 20px;
    background: #305dc3;
    border-radius: 5px;
  }
  .panel { display: none; }
  .block h1,
  .photo,
  .copy {
    position: static;
    width: auto;
    left: auto;
    top: auto;
  }
  .block h1 {
    display: table;
    margin: 0 auto 16px;
    background: #fff;
  }
  .photo {
    display: block;
    width: 100%;
    height: 200px !important;
    margin-bottom: 16px;
  }
}
</style>
